import {
  TrackingClient,
  TrackingPageContext,
} from '@aboutyou/legacy-tracking-sdk';
import {useContext} from 'react';
import {useTrackingPageContextCallback} from '../context/PageTrackingContext';
import {
  GTMTrackingClient,
  searchEventTypes,
} from '../context/TrackingClientContext';

interface TrackingContextAndClient {
  TrackingClient: TrackingClient;
  pageContextCallback: () => TrackingPageContext;
  /**
   * Informs the customer data event handler to track or not track the next update
   * @private
   * @deprecated Please don't consider this good practice. Better bundle actions in the sdk.
   */
  shouldFireCustomerDataEvent: () => boolean;
  /**
   * Allows to disable the customer data event handler
   * @private
   * @deprecated Please don't consider this good practice. Better bundle actions in the sdk.
   */
  resetCustomerDataEventScheduler: () => void;
  /**
   * Allows to activate the customer data event handler
   * @private
   * @deprecated Please don't consider this good practice. Better bundle actions in the sdk.
   */
  scheduleCustomerDataEvent: (cb?: () => void) => void;
  /**
   * Fires potential callbacks registered to be called after the customer data event
   * @private
   * @deprecated Please don't consider this good practice. Better bundle actions in the sdk.
   */
  fireCustomerDataCallback: () => void;

  getSearchEventParams: () => null | searchEventTypes;
  updateSearchEventParams: (
    params: Omit<searchEventTypes, 'shouldFire'>,
  ) => void;
  resetSearchEventParams: () => void;
}

export function useTracking(): TrackingContextAndClient {
  const pageContextCallback = useTrackingPageContextCallback();
  const {
    client,
    shouldFireCustomerDataEvent,
    resetCustomerDataEventScheduler,
    scheduleCustomerDataEvent,
    fireCustomerDataCallback,
    getSearchEventParams,
    resetSearchEventParams,
    updateSearchEventParams,
  } = useContext(GTMTrackingClient);

  return {
    pageContextCallback,
    TrackingClient: client,
    shouldFireCustomerDataEvent,
    resetCustomerDataEventScheduler,
    scheduleCustomerDataEvent,
    fireCustomerDataCallback,
    getSearchEventParams,
    resetSearchEventParams,
    updateSearchEventParams,
  };
}
